import { feature as accountActionsFeature } from '@central-products/account-actions';

export const accountActionsPlugin = {
  beforeBootstrap({ addBootstrapperFeature, params }) {
    addBootstrapperFeature(accountActionsFeature, params);
  },
};
